import { Fragment } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";

const DootToDoorPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}
        {pageText}
        {pageImage}
      </main>

      <Footer />
    </Fragment>
  );
};

export default DootToDoorPage;
